"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const isPlainObject_1 = tslib_1.__importDefault(require("lodash/isPlainObject"));
const simple_react_form_1 = require("simple-react-form");
const includes_1 = tslib_1.__importDefault(require("lodash/includes"));
class AutoFormField extends react_1.default.Component {
    renderObjectFields(fields) {
        const currentOmit = this.props.omit
            .filter(key => key && key.startsWith(this.props.fieldName + '.'))
            .map(key => key.replace(this.props.fieldName + '.', ''));
        const currentOnly = this.props.only
            .filter(key => key && key.startsWith(this.props.fieldName + '.'))
            .map(key => key.replace(this.props.fieldName + '.', ''));
        return Object.keys(fields)
            .filter(key => (currentOnly.length ? (0, includes_1.default)(currentOnly, key) : true))
            .filter(key => !(0, includes_1.default)(currentOmit, key))
            .map(key => {
            return (react_1.default.createElement(AutoFormField, { key: key, field: fields[key], fieldName: key, getFieldComponent: this.props.getFieldComponent, passProps: this.props.passProps, omit: currentOmit, only: currentOnly }));
        });
    }
    renderField(field) {
        const { type, label, placeholder, description, fieldType, fieldOptions = {} } = field;
        const props = {
            label,
            placeholder,
            description,
            ...fieldOptions,
            ...this.props.passProps,
            fieldName: this.props.fieldName
        };
        if (fieldType) {
            props.type = this.props.getFieldComponent(field);
        }
        else if ((0, isArray_1.default)(type) && (0, isPlainObject_1.default)(type[0])) {
            props.type = this.props.getFieldComponent({ fieldType: 'array' });
            props.children = this.renderObjectFields(type[0]);
        }
        else if ((0, isPlainObject_1.default)(type)) {
            props.type = this.props.getFieldComponent({ fieldType: 'plainObject' });
            props.children = this.renderObjectFields(type);
        }
        else {
            props.type = this.props.getFieldComponent(field);
        }
        return react_1.default.createElement(simple_react_form_1.Field, { ...props });
    }
    render() {
        return this.renderField(this.props.field);
    }
}
exports.default = AutoFormField;
//# sourceMappingURL=index.js.map